import Vue from 'vue'
import App from './App.vue'
import lodash from 'lodash'
import router from './router/router.js'
import store from './store/index.js'
import Print from './untils/print.js'
import moment from 'moment'
import 'default-passive-events'
import '@/icons'
import * as echarts from 'echarts';
import vcolorpicker from 'vcolorpicker'
import VueParticles from 'vue-particles'  
Vue.use(VueParticles)
Vue.use(vcolorpicker)
Vue.use(Print)
Vue.prototype._date = (time,length) => {  
  if(length == undefined){
      length = 19;
  } 
  // let zone = new Date(time*1000).getTimezoneOffset()/60;
  var day = moment((time-0)*1000).utc(8).format("YYYY-MM-DD");
  return day
}
// 重新写入 toFixed 方法
Number.prototype.toFixed = function (n) {

  if (n > 20 || n < 0) {
      throw new RangeError('toFixed() digits argument must be between 0 and 20');
  }
  const number = this;
  if (isNaN(number) || number >= Math.pow(10, 21)) {
      return number.toString();
  }

  if (typeof (n) == 'undefined' || n == 0) {
      return (Math.round(number)).toString();
  }
  let result = number.toString();
  const arr = result.split('.');
  // 整数的情况
  if (arr.length < 2) {
      result += '.';
      for (let i = 0; i < n; i += 1) {
          result += '0';
      }
      return result;
  }
  const integer = arr[0];
  const decimal = arr[1];
  if (decimal.length == n) {
      return result;
  }

  if (decimal.length < n) {
      for (let i = 0; i < n - decimal.length; i += 1) {
          result += '0';
      }
      return result;
  }
  result = integer + '.' + decimal.substr(0, n);
  const last = decimal.substr(n, 1);
  // 四舍五入，转换为整数再处理，避免浮点数精度的损失
  if (parseInt(last, 10) >= 5) {
      const x = Math.pow(10, n);
      result = (Math.round((parseFloat(result) * x)) + 1) / x;
      result = result.toFixed(n);
  }
  return result;
}

Vue.config.productionTip = false

Vue.prototype.$ = lodash

Vue.prototype.$echarts = echarts;

Vue.prototype.setToken = token => {
  return window.sessionStorage.setItem('token',token)
}
Vue.prototype.getToken = () => {
  return window.sessionStorage.getItem('token')
}
Vue.prototype.removeToken = () => {
  return window.sessionStorage.removeItem('token')
}
Vue.prototype.validate = params => {
  for(let key in params){
    if(params[key] === '' || params[key] === undefined || params[key] === null){
      return false   // 终止程序
    }
  }
  return true
}








new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
